import Vue from "vue"
import App from "./App.vue"
import store from "@/store"
import VueLazyload from "vue-lazyload"

import "swiper/css/swiper.css"
import VueAwesomeSwiper from "vue-awesome-swiper"
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "./static/images/bg_default.png",
  loading: "./static/images/bg_default.png",
  attempt: 1
})

new Vue({
  store,
  render: h => h(App)
}).$mount("#app")
